import script from "./AdditionalMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AdditionalMenu.vue?vue&type=script&setup=true&lang=js"

import "./AdditionalMenu.vue?vue&type=style&index=0&id=7d665be0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d665be0"]])

export default __exports__